import React from "react";

const ErrorText = ({text, className}) => {
    return (
        <p style={{
            color: 'var(--danger)',
            fontSize: '14px',
            margin: '0 0 12px',
        }} className={className}>
            {text}
        </p>
    )
};

export default ErrorText;
